import vr_video_source from '../mixins/vr_video_source'
import get_userinfo from '../mixins/getUserInfo'
export default {
    mixins: [
        vr_video_source,
        get_userinfo
    ],
    data () {
        return {
            tmp_img_path: '',
            show_success: false,
            show_billboard: false,
            billboard_height: 0
        }
    },
    onLoad () {
        const { building_id } = this.$route.query
        this.getUser(building_id)
    },
    methods: {
        changeBillboardHeight (billboard_height) {
            this.billboard_height = billboard_height
        },
        showBillboard () {
            this.show_billboard = true
        },
        hideBillboard () {
            this.show_billboard = false
            this.hideSaveImg()
        },
        drawComplete (tmp_img_path) {
            this.tmp_img_path = tmp_img_path
        },
        saveImgSuccess () {
            this.show_success = true
        },
        tapBillboard () {},
        hideSaveImg () {
            this.show_success = false
            this.show_billboard = false
        }
    }
}
